import React, { Component } from "react";
import { Auth, API } from "aws-amplify";
import { withRouter } from "react-router";
import { compose } from "recompose";
// import { loadReCaptcha } from "react-recaptcha-google";
import i18n from "./i18n";
import moment from "moment";
import "moment/locale/fr";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";

import Routes from "./routes";
import { getNoticeBanner, getEmergencyMode } from "./services/setting";

import "typeface-roboto";
import "./App.css";
import createHistory from "history/createBrowserHistory";
import analytics from "./analytics";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
});
/*
export const history = createHistory();
history.listen((location, action) => {
  if (location.hash.slice(0, 2) === "#s") {
    window.scrollTo(window.scrollX, window.scrollY);
  }
});*/

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: null,
      userNeedNewPassword: null,
      isAuthenticated: false,
      isAuthenticating: true,
      isEmergencyMode: false,
      noticeBanner: { enabled: false, message: "", messageFr: "" },
    };
  }

  userHasAuthenticated = (authenticated) => {
    this.setState({ isAuthenticated: authenticated });
  };

  setUserNeedNewPassword = (userNeedNewPassword) => {
    this.setState({ userNeedNewPassword });
  };

  setUserAttributes = ({ attributes }) => {
    this.setState({
      user: attributes,
    });
  };

  handleLogout = async (event) => {
    await Auth.signOut();
    analytics.track("logout_completed", {});
    this.userHasAuthenticated(false);
    const currentRoute = this.props.history.location.pathname;
    const routePattern = /^\/seats\/[^\/]+\/[^\/]+\/[^\/]+$/;
    const onCheckoutPage = routePattern.test(currentRoute);
    if (onCheckoutPage) {
      window.location.reload();
    } else {
      this.props.history.push(currentRoute);
    }
  };

  async componentDidMount() {
    analytics.identify();
    this._analyticsUnlisten = this.props.history.listen((location) => {
      analytics.page(location.pathname);
    });
    analytics.page(this.props.history.location.pathname);

    try {
      const currentLang = (i18n && i18n.language) || "en";
      const hl = currentLang && currentLang.toLowerCase().startsWith("fr") ? "fr" : "en";
      // Set moment locale to match UI language
      try {
        moment.locale(hl);
        if (hl === 'fr') {
          const frMonthsShort = ['janv.','févr.','mars','avr.','mai','juin','juill.','août','sept.','oct','nov.','déc'];
          const frWeekdaysShort = ['dim.','lun.','mar.','mer.','jeu.','ven.','sam.'];
          try {
            moment.updateLocale('fr', { monthsShort: frMonthsShort, weekdaysShort: frWeekdaysShort });
            moment.updateLocale('fr-ca', { monthsShort: frMonthsShort, weekdaysShort: frWeekdaysShort });
          } catch (_) {}
        }
      } catch (_) {}
      // Update moment locale when language changes
      try {
        i18n.on('languageChanged', (lng) => {
          const l = (lng || '').toLowerCase().startsWith('fr') ? 'fr' : 'en';
          moment.locale(l);
          if (l === 'fr') {
            const frMonthsShort = ['janv.','févr.','mars','avr.','mai','juin','juill.','août','sept.','oct','nov.','déc'];
            const frWeekdaysShort = ['dim.','lun.','mar.','mer.','jeu.','ven.','sam.'];
            try {
              moment.updateLocale('fr', { monthsShort: frMonthsShort, weekdaysShort: frWeekdaysShort });
              moment.updateLocale('fr-ca', { monthsShort: frMonthsShort, weekdaysShort: frWeekdaysShort });
            } catch (_) {}
          }
        });
      } catch (_) {}
      const existing = document.querySelector('script[src^="https://www.google.com/recaptcha/api.js"]');
      if (!existing) {
        const script = document.createElement("script");
        script.async = true;
        script.defer = true;
        script.src = `https://www.google.com/recaptcha/api.js?hl=${encodeURIComponent(hl)}`;
        document.body.appendChild(script);
      }
    } catch (_) {
      // captcha fail
    }
    try {
      await Auth.currentSession();

      this.userHasAuthenticated(true);

      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
      this.setUserAttributes(user);
      this.setState({
        isAuthenticating: false,
      });
    } catch (e) {
      this.setState({
        isAuthenticating: false,
      });
    }
    
    const [noticeBanner, isEmergencyMode] = await Promise.all([
      getNoticeBanner(),
      getEmergencyMode(),
    ]);

    this.setState({
      noticeBanner,
      isEmergencyMode,
    });
  }

  componentWillUnmount() {
    if (this._analyticsUnlisten) {
      this._analyticsUnlisten();
      this._analyticsUnlisten = null;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    (prevState.isAuthenticating !== this.state.isAuthenticating) && window.scrollTo(0, 0);
    if (prevState.isEmergencyMode !== this.state.isEmergencyMode) {
      if (
        this.state.isEmergencyMode == "True" &&
        window.location.pathname != "/under-maintenance"
      ) {
        window.location.replace("/under-maintenance");
      } else if (
        this.state.isEmergencyMode == "False" &&
        window.location.pathname == "/under-maintenance"
      ) {
        window.location.replace("/");
      }
    }
  }

  render() {
    const { classes } = this.props;
    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated,
      setUserAttributes: this.setUserAttributes,
      currUser: this.state.user,
      handleLogout: this.handleLogout,
      history: this.props.history,
      userNeedNewPassword: this.state.userNeedNewPassword,
      setUserNeedNewPassword: this.setUserNeedNewPassword,
    };

    return (
      !this.state.isAuthenticating && (
        <React.Fragment>
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org/",
              "@type": "WebSite",
              name: "FANSFIRST",
              url: "https://www.fansfirst.ca/",
              potentialAction: {
                "@type": "SearchAction",
                target:
                  "https://www.fansfirst.ca/search?q={search_term_string}",
                "query-input": "required name=search_term_string",
              },
            })}
          </script>

          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Organization",
              name: "FANSFIRST",
              url: "https://www.fansfirst.ca/",
              logo: "https://www.fansfirst.ca/static/media/logo.165f4bb7.png",
              sameAs: [
                "https://www.facebook.com/fansfirst.ca",
                "https://www.instagram.com/fansfirst.ca",
                "https://www.twitter.com/FansFirstTix",
              ],
            })}
          </script>

          <CssBaseline />
          <div id="App" className={classes.root}>
            <Routes childProps={{
              ...childProps,
              noticeBanner: this.state.noticeBanner
            }} />
          </div>
        </React.Fragment>
      )
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(withStyles(styles), withRouter)(App);
